module.exports = VueRouter;


//////////////////
// WEBPACK FOOTER
// external "VueRouter"
// module id = 93
// module chunks = 0 1 2 3 4 5 6